export default {"src":"/_next/static/media/bookmark-theme-icon.36782e0a.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};